/*
 * Better Turns POS System
 * Copyright (c) 2024 Better Turns LLC
 * All rights reserved.
 *
 * Author: Gabe Mohacsi
 * Description: Main Footer to used as the base for the footer of each page.
 * License: Proprietary - Redistribution, modification, or use without
 * explicit permission from Better Turns LLC is prohibited.
 */

// client/src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-primary text-white py-8 mt-12">
      <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-6 text-center md:text-left">
        <div>
          <h3 className="text-lg font-semibold mb-2">BetterTurns Co-op</h3>
          <p className="text-sm text-mint-green">
            Empowering independent retailers to grow together.
          </p>
          <Link
            to="/manifesto"
            className="text-sm mt-2 inline-block text-sunshine-yellow hover:text-warm-orange font-medium"
          >
            Read Our Manifesto →
          </Link>
          <p>
            <Link
              to="/opportunities"
              className="text-mint-green hover:text-white"
            >
              Join Our Team →
            </Link>
          </p>
          <Link
            to="/partners"
            className="text-sm hover:underline text-mint-green"
          >
            Partner With Us
          </Link>
        </div>

        <div>
          <h4 className="font-semibold mb-2">Navigation</h4>
          <ul className="space-y-1 text-sm">
            <li>
              <Link
                to="/"
                className="hover:underline"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className="hover:underline"
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/join"
                className="hover:underline"
              >
                Join
              </Link>
            </li>
            <li>
              <Link
                to="/resources"
                className="hover:underline"
              >
                Resources
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-2">Contact</h4>
          <p className="text-sm">Palm Harbor, FL</p>
          <p className="text-sm">info@betterturn.com</p>
        </div>
      </div>

      <div className="mt-8 text-center text-xs text-soft-earth">
        &copy; {new Date().getFullYear()} BetterTurnsRetail.com. All rights
        reserved.
      </div>
    </footer>
  );
};

export default Footer;
